import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { Box, Stack, Typography, IconButton, CardMedia, Grid, Skeleton, Dialog, TextField } from "@mui/material";

import KeywordCategoryChart from "../chart/KeywordCategoryChart";
import MonthltyKeywordChart from "../chart/MonthltyKeywordChart";

import "./PopChartDetail.css";

interface propsType {
  callback: any;
}

const PopChartDetail = (props: propsType, ref: any) => {
  const [openModal, setOpenModal] = useState(false);
  const [flag, setFlag] = useState("");
  const [chartData, setChartData] = useState<any>(null);

  useEffect(() => {
    return () => {
      setOpenModal(false);
      setChartData(null);
      setFlag("");
    };
  }, []);

  const open = (flag: string, info: any) => {
    setFlag(flag);
    setChartData(info);
    setOpenModal(true);
  };

  const close = () => {
    props.callback({ command: "close" });
    setOpenModal(false);
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <>
      <Dialog
        open={openModal}
        onClose={close}
        PaperProps={{
          style: {
            width: "100%",
            // minWidth: "90%",
            maxWidth: "990px",
            background: "#ffffff",
            borderRadius: "30px",
          },
        }}
      >
        <Box sx={{ p: 2 }} className="chart-modal">
          <Box className="header">
            <Box className="title">
              <Typography className="text">{flag === "keyword" ? "키워드별 카테고리 분포" : "월별 키워드 언급량 추이"}</Typography>
            </Box>
            <Box className="btn">
              <IconButton
                onClick={() => {
                  close();
                }}
              >
                <CardMedia component={"img"} image="/images/icon-close-m-blk.png" sx={{ height: "22px" }} />
              </IconButton>
            </Box>
          </Box>
          <Box className="title-margin"></Box>
          <Box className="content">
            <Box className="chart">
              {flag === "keyword" ? <KeywordCategoryChart chartData={chartData} /> : <MonthltyKeywordChart chartData={chartData} />}
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default forwardRef(PopChartDetail);
